import { render, staticRenderFns } from "./errorTestB.vue?vue&type=template&id=9074a41c"
import script from "./errorTestB.vue?vue&type=script&lang=js"
export * from "./errorTestB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports